import { makeStyles } from '@material-ui/core'

export const historyStyles = makeStyles((theme: any) => {
  return {
    headerWrapper: {
      padding: theme.spacing(1),
      paddingRight: 0,
      height: theme.history.titleHeight,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      boxSizing: 'border-box',
    },
    contentIndent: {
      paddingLeft: theme.spacing(1),
    },
    exportButton: {
      whiteSpace: 'nowrap',
    },
    exportButtonWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: theme.history.buttonWrapperHeight,
    },
  }
})

